import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-7cade96a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "overlay-wrapper" };
var _hoisted_2 = /*#__PURE__*/ _createTextVNode("加载中...");
import { useRoute } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup: function (__props) {
        var route = useRoute();
        var loginVisible = true;
        var token = localStorage.getItem("token");
        var openId = sessionStorage.getItem("openId");
        var userType = route.query.userType || "1"; // 用户类型，1 普通用户，2业务员，3医生
        if (token && openId) {
            if (localStorage.getItem("userType")) {
                if ((userType === "1" &&
                    ["2", "3"].includes(localStorage.getItem("userType"))) ||
                    (userType === "2" && localStorage.getItem("userType") === "1")) {
                    localStorage.clear();
                    localStorage.setItem("userType", userType);
                    location.replace("/login");
                }
                else {
                    switch (+localStorage.getItem("userType")) {
                        case 1:
                            location.replace("/products");
                            break;
                        case 2:
                            location.replace("/salesman-personal-center");
                            break;
                        case 3:
                            location.replace("/doctor-list");
                            break;
                    }
                }
            }
            else {
                localStorage.setItem("userType", userType);
                switch (+userType) {
                    case 1:
                        location.replace("/products");
                        break;
                    case 2:
                        location.replace("/salesman-personal-center");
                        break;
                    case 3:
                        location.replace("/doctor-list");
                        break;
                }
            }
        }
        else {
            if ((userType === "1" &&
                ["2", "3"].includes(localStorage.getItem("userType"))) ||
                (userType === "2" && localStorage.getItem("userType") === "1")) {
                localStorage.clear();
                localStorage.setItem("userType", userType);
            }
            if (!localStorage.getItem("userType")) {
                localStorage.setItem("userType", userType);
            }
            location.replace("/login");
        }
        return function (_ctx, _cache) {
            var _component_van_loading = _resolveComponent("van-loading");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_loading, {
                    color: "#0094ff",
                    size: "24px",
                    vertical: ""
                }, {
                    default: _withCtx(function () { return [
                        _hoisted_2
                    ]; }),
                    _: 1
                })
            ], 512)), [
                [_vShow, loginVisible]
            ]);
        };
    }
});
